import _ from "lodash";

import * as addDynamicForm from '@/api/crm/dynamicForms/addDynamicForm';
import * as updateDynamicForm from '@/api/crm/dynamicForms/updateDynamicForm';
import * as deleteDynamicForm from '@/api/crm/dynamicForms/deleteDynamicForm';
import * as getDynamicForms from '@/api/crm/dynamicForms/getDynamicForms.js';
import * as getVenueCheckIns from '@/api/crm/dynamicForms/getVenueCheckIns.js';
import * as previewForVenue from '@/api/crm/dynamicForms/previewForVenue.js';
import * as exportDynamicForm from '@/api/crm/dynamicForms/exportDynamicForm.js';


export default {
    namespaced: true,
    state: {
        formOpenTypes: ["Automatic", "Manual"],
        dynamicForms: [],
        venueCheckIns: []
    },
    mutations: {
        gotDynamicForms(state, result) {
            state.dynamicForms = result;
        },
        gotVenueCheckIns(state, result) {
            state.venueCheckIns = result;
        },
    },
    actions: {
        async getVenueCheckIns({ commit, getters }, force = true) {
            if (!force && getters.venueCheckIns.length > 0) return;
            const result = await getVenueCheckIns.get();
            if (result) commit("gotVenueCheckIns", result);
        },
        async getAll({ commit, getters }, force = true) {
            if (!force && getters.dynamicForms.length > 0) return;
            const result = await getDynamicForms.get();
            if (result) commit("gotDynamicForms", result);
        },

        async create({ dispatch }, dto) {
            await addDynamicForm.post(dto);
            await dispatch("getAll")
        },
        async update({ dispatch }, dto) {
            await updateDynamicForm.put(dto);
            await dispatch("getAll")
        },
        async delete({ dispatch }, id) {
            await deleteDynamicForm.del(id);
            await dispatch("getAll")
        },
        async previewForVenue({ dispatch }, dto) {
            return await previewForVenue.post(dto);
        },
        async exportDynamicForm({ dispatch }, dto) {
            await exportDynamicForm.post(dto);
        }

    },
    getters: {
        formOpenTypes: state => state.formOpenTypes,
        dynamicForm: state => (id) => state.dynamicForms.find(e => e.id === id),
        dynamicForms: state => state.dynamicForms,
        venueCheckIns: state => state.venueCheckIns,
    }
};
